import { useEffect, useRef, useState } from "react";
import upArrow from "../up-arrow.png";


const GoUp = () => {
    const arrowLink = useRef(null);
    const [showArrow, setShowArrow] = useState(false)
    useEffect(() => {
        if (window && setShowArrow) {
            window.addEventListener('scroll', () => setShowArrow(window.scrollY > 800))
        }
        
    }, [setShowArrow])
    
    const goUp = event => {
        event.preventDefault();          
        document.querySelector(event.currentTarget.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        })
    }

    return (
        <>
            {showArrow && 
                <a 
                    href="#header" 
                    ref={arrowLink}
                    onClick={goUp}
                    style={{
                        display: `block`,
                        position: `fixed`,
                        bottom: `2rem`,
                        right: `2rem`,
                        background: `#7a8e89`,
                        padding: `1rem`,
                        borderRadius: `1rem`,
                    }}
                >
                    <img src={upArrow} alt="Subir" style={{width: 64}} />
                </a>
            }
        </>
    )
}

export default GoUp